<template>
<div class="container-fluid">

	<toolbar>
		<h2>Child Form Template Editor</h2>
	</toolbar>

	<vue-form v-on:submit="saveChildTemplate" :no-top-button="true" size="md">

		<div class="d-flex justify-content-between mb-2">
			<router-link :to="backLink">
				<i class="fa fa-arrow-left"></i>
				Back to templates list
			</router-link>

			<div>
				<context-menu :menu-items="[
						{
							text: 'Clone Child Template',
							icon: 'fa-clone',
							clickFunction: 'cloneChildTemplate',
						},
						{
							text: 'Delete Child Template',
							icon: 'fa-trash',
							itemClass: 'text-danger',
							clickFunction: 'deleteChildTemplate',
						}
					]"
					v-on:deleteChildTemplate="deleteChildTemplate"
					v-on:cloneChildTemplate="cloneChildTemplate">
				</context-menu>
			</div>
		</div>

		<field label="Template"
			col-class="col-4 col-md-3"
			v-model="template_id"
			:params="{type:'select',options:formTemplateOptions}"
			v-on:change="selectTemplate"
			:invalid="$store.errorList.template_id">
		</field>

		<field label="Description"
			col-class="col-4 col-md-3"
			v-model="description"
			:invalid="$store.errorList.description">
		</field>

		<field label="Prompt on service job clock-in"
			col-class="col-4 col-md-3"
			v-model="clockin_prompt_services"
			:params="{type:'boolean'}"
			:invalid="$store.errorList.clockin_prompt_services">
		</field>

		<!--
		<field v-if="clockin_prompt_services == 1"
			label="Required to submit?"
			class="ml-3"
			col-class="col-4 col-md-3"
			v-model="clockin_prompt_services_required"
			:params="{type:'boolean'}"
			:invalid="$store.errorList.clockin_prompt_services_required">
		</field>
		-->

		<field label="Prompt on project clock-in"
			col-class="col-4 col-md-3"
			v-model="clockin_prompt_projects"
			:params="{type:'boolean'}"
			:invalid="$store.errorList.clockin_prompt_projects">
		</field>

		<!--
		<field v-if="clockin_prompt_projects == 1"
			label="Required to submit?"
			class="ml-3"
			col-class="col-4 col-md-3"
			v-model="clockin_prompt_projects_required"
			:params="{type:'boolean'}"
			:invalid="$store.errorList.clockin_prompt_projects_required">
		</field>
		-->

		<form-group label="Expiry Interval"
			col-class="col-4 col-md-3">

			<div v-if="companyFormRecurring.length" class="w-100 mb-2">
				<div v-for="(record, index) in mutatedRecurring" class="list-group-item d-flex justify-content-between">

					<div class="d-flex">
						<div class="text-center mr-2" style="min-width: 25px;">
							<i :class="'fa text-primary mr-2 ' + record.icon"></i>
						</div>
						{{record.name}}
					</div>

					<div>
						Every {{record.intervalText}}

						<i
							class="fa fa-trash text-danger icon-button ml-2"
							style="font-size: 18px;"
							v-on:click="openDeleteRecurranceModal(index)"></i>
					</div>
				</div>
			</div>


			<button v-if="id > 0"  type="button" class="btn btn-primary btn-sm" v-on:click="openRecurranceModal">
				<i class="fa fa-plus"></i>
				Add Employee/Group
			</button>
			<div v-else>Employees/Groups can be added once the child template has been saved</div>

			<div class="text-muted mt-1">Set intervals for when this form should be re-completed by certain employees and employee classification groups.</div>

		</form-group>

		<form-fillable v-model="childTemplate"
			:is-child-template="true">
		</form-fillable>

	</vue-form>

	<modal-dialog :modal-visible="confirmDeleteModalVisible"
		title="Delete Child Template"
		confirm-button-text="Yes, Delete"
		button-class="btn-outline-danger"
		modal-class="modal-danger"
		v-on:closeModal="confirmDeleteModalVisible = false"
		v-on:confirm="confirmDeleteChildTemplate">

		Are you sure you want to delete this child template?

	</modal-dialog>


	<modal-dialog
		:modal-visible="recurranceModal.visible"
		title="Add an Employee / Classification"
		confirm-button-text="Add"
		v-on:closeModal="recurranceModal.visible = false"
		v-on:confirm="saveRecurring">

		<field
			class="mb-4"
			:params="{
				type:'btn-group',
				buttons: [
					{text:'Employee',             value:'user'},
					{text:'Classification',       value:'employee-classification'}
				],
				disableNull: true
			}"
			v-model="recurranceModal.tab">
		</field>

		<field
			v-if="recurranceModal.tab == 'user'"
			label="Employee"
			col-class="col-3"
			:params="{type:'select', options: employeeOptions}"
			v-model="recurranceModal.selectedUserId"
			:invalid="$store.errorList.user_id">
		</field>

		<field
			v-else-if="recurranceModal.tab == 'employee-classification'"
			label="Employee Classification"
			col-class="col-3"
			:params="{type:'select', options: groupOptions}"
			v-model="recurranceModal.selectedClassificationId"
			:invalid="$store.errorList.classification_id">
		</field>

		<field
			label="Interval"
			col-class="col-3"
			:params="{type:'select',options: intervalOptions}"
			v-model="recurranceModal.selectedInterval"
			:invalid="$store.errorList.interval">
		</field>

	</modal-dialog>

	<modal-dialog
		:modal-visible="confirmDeleteRecurranceModal.visible"
		title="Delete Expiry Interval"
		confirm-button-text="Yes, Delete"
		button-class="btn-outline-danger"
		modal-class="modal-danger"
		v-on:closeModal="confirmDeleteRecurranceModal.visible = false"
		v-on:confirm="deleteRecurrance">

		Are you sure you want to delete this expiry interval?

	</modal-dialog>

</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import Field from "@/components/Field"
import VueForm from "@/components/VueForm"
import ModalDialog from "@/components/ModalDialog"
import ContextMenu from "@/layout_fragments/ContextMenu"
import FormGroup from "@/components/FormGroup"

import FormFillable from "@/components/company_forms/FormFillable"
import FormMixins from "@/mixins/FormMixins"
import draggable from 'vuedraggable'

export default {
	name: "FormChildTemplateEditor",
	components: {
		Field,
		Toolbar,
		draggable,
		FormFillable,
		VueForm,
		ModalDialog,
		ContextMenu,
		FormGroup
	},
	mixins: [FormMixins],
	data() {
		return {
			id: null,
			childTemplate: [],
			description: "",
			clockin_prompt_services: false,
			clockin_prompt_services_required: false,
			clockin_prompt_projects: false,
			clockin_prompt_projects_required: false,
			template_id: null,
			formTemplates: [],
			confirmDeleteModalVisible: false,

			recurringInclude: [
				{ model: 'User',                   fields: ['id', 'first_name', 'last_name'] },
				{ model: 'EmployeeClassification', fields: ['id', 'title'] }
			],
			companyFormRecurring: [],        // fetched (in FormChildTemplate)
			employeeClassifications: [],     // fetched
			intervalOptions: [
				{text: '1 day',    value: 'P1D'},
				{text: '2 days',   value: 'P2D'},
				{text: '3 days',   value: 'P3D'},
				{text: '4 days',   value: 'P4D'},
				{text: '5 days',   value: 'P5D'},
				{text: '6 days',   value: 'P6D'},
				{text: '7 days',   value: 'P7D'},
				{text: '14 days',  value: 'P14D'},
				{text: '30 days',  value: 'P30D'},
				{text: '1 month',  value: 'P1M'},
				{text: '2 months', value: 'P2M'},
				{text: '3 months', value: 'P3M'},
				{text: '6 months', value: 'P6M'},
				{text: '1 year',   value: 'P1Y'},
				{text: '2 years',  value: 'P2Y'},
				{text: '3 years',  value: 'P3Y'}
			],

			recurranceModal: {
				visible: false,
				tab: 'user',                   // 'user' or 'employee-classification'
				selectedUserId: null,
				selectedClassificationId: null,
				selectedInterval: null
			},

			confirmDeleteRecurranceModal: {
				visible: false,
				index: -1
			}
		}
	},
	computed: {
		employeeOptions() {
			return this.userOptions()
				.filter(option => {
					return !this.companyFormRecurring.find(record => 'User' in record && record.User && record.User.id == option.value)
				})
		},
		groupOptions() {
			return this.optionify(this.employeeClassifications, 'title')
				.filter(option => {
					return !this.companyFormRecurring.find(record => 'EmployeeClassification' in record && record.EmployeeClassification && record.EmployeeClassification.id == option.value)
				})
		},
		mutatedRecurring() {
			return this.companyFormRecurring.map(record => {

				record.icon = ""
				record.name = ""

				if ('User' in record && record.User) {
					let tokens = []

					if ('first_name' in record.User && record.User.first_name)
						tokens.push(record.User.first_name)
					if ('last_name' in record.User && record.User.last_name)
						tokens.push(record.User.last_name)

					record.name = tokens.join(' ')
					record.icon = "fa-user"
				}

				else if ('EmployeeClassification' in record && record.EmployeeClassification) {
					record.name = record.EmployeeClassification.title
					record.icon = "fa-users"
				}

				const interval = this.intervalOptions.find(option => option.value == record.interval)
				record.intervalText = (interval) ? interval.text : ""

				return record
			})
		},
		backLink() {
			if ("template_slug" in this.$route.params) {
				let template = this.formTemplates.find(template => {
					if (template && "title" in template && template.title)
						return template.title.slugify() == this.$route.params.template_slug
				})

				if (template && "FormTemplateCategory" in template && template.FormTemplateCategory)
					return "/forms/templates/"+template.FormTemplateCategory.name.slugify()+"/"+template.title.slugify()
			}

			return "/forms/templates"
		},
		categoryOptions() {
			return this.optionify(this.categories,'name')
		},
		mutatedCategories() {
			let mutated = this.categories.map(cat => {
				cat.text = cat.name
				cat.link = "/safety/forms/"+cat.name.slugify()

				return cat
			})

			mutated.unshift({
				text: "All", link: "/safety/forms"
			})

			return mutated
		},
		formTemplateOptions() {
			return this.optionify(this.formTemplates,"title")
		}
	},
	methods: {
		deleteRecurrance() {
			const vm = this

			const itemIndex = this.confirmDeleteRecurranceModal.index
			const item = this.companyFormRecurring[itemIndex]

			const payload = {
				id: item.id
			}

			this.postData('CompanyFormRecurring/delete', payload).then(response => {
				if (response.success) {
					vm.alertSuccess('Expiry interval deleted.')

					// recompute index in case it changed during fetch
					const newIndex = vm.companyFormRecurring.findIndex(record => record.id == payload.id)
					if (newIndex > -1)
						vm.companyFormRecurring.splice(newIndex, 1)

					vm.confirmDeleteRecurranceModal.visible = false
				}
			})
		},
		openDeleteRecurranceModal(index) {
			this.confirmDeleteRecurranceModal.index = index
			this.confirmDeleteRecurranceModal.visible = true
		},
		setErrors(errors) {
			this.$set(this.$store, 'errorList', errors)
			this.alertErrors(errors)
		},
		saveRecurring() {
			const vm = this

			let payload = {
				child_template_id: this.id,
				interval: this.recurranceModal.selectedInterval
			}

			// Manual validation because the endpoint does NOT require user_id or classification_id
			if (this.recurranceModal.tab == 'user') {
				payload.user_id = this.recurranceModal.selectedUserId

				if (!payload.user_id) {
					this.setErrors({user_id: "The Employee field is required"})
					return
				}
			}

			else if (this.recurranceModal.tab == 'employee-classification') {
				payload.classification_id = this.recurranceModal.selectedClassificationId

				if (!payload.classification_id) {
					this.setErrors({classification_id: "The Employee Classification field is required"})
					return
				}
			}

			this.postData('CompanyFormRecurring/save', payload, true).then(response => {
				if (response.success) {

					const params = {
						include: vm.recurringInclude
					}

					vm.getJSON('CompanyFormRecurring/find/' + response.data.record_id, params, true).then(fetchResponse => {
						if (fetchResponse.success) {
							vm.companyFormRecurring.push(fetchResponse.data)
						}
					})

					vm.alertSuccess('Expiry interval saved.')
					vm.recurranceModal.visible = false
				}
			})
		},
		openRecurranceModal() {
			this.recurranceModal.tab = 'user'
			this.recurranceModal.selectedUserId = null
			this.recurranceModal.selectedClassificationId = null
			this.recurranceModal.visible = true
		},
		setChildTemplate(record) {
			if ("id" in record)
				this.id = record.id

			this.template_id = record.form_template_id
			this.description = record.description
			this.clockin_prompt_services = record.clockin_prompt_services
			this.clockin_prompt_projects = record.clockin_prompt_projects

			this.companyFormRecurring = []
			if ('CompanyFormRecurring' in record && record.CompanyFormRecurring)
				this.companyFormRecurring = record.CompanyFormRecurring

			let templateObj = []
			try {
				templateObj = JSON.parse(record.form_json)
			}
			catch (e) {}

			this.childTemplate = templateObj
		},
		setChildTemplateValues(values) {
			//this.childTemplate = values
		},
		deleteChildTemplate() {
			this.confirmDeleteModalVisible = true
		},
		confirmDeleteChildTemplate() {
			let vm = this

			this.postData("FormChildTemplate/delete",{id: this.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Child template deleted")
					vm.$router.push(vm.backLink)
				}
			})
		},
		cloneChildTemplate() {
			let vm = this

			let payload = {
				form_template_id: this.template_id,
				clockin_prompt_projects: this.clockin_prompt_projects,
				clockin_prompt_projects_required: this.clockin_prompt_projects_required,
				clockin_prompt_services: this.clockin_prompt_services,
				clockin_prompt_services_required: this.clockin_prompt_services_required,
				form_json: JSON.stringify(this.childTemplate),
				description: this.description+" (cloned)"
			}

			this.postData("FormChildTemplate/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Child template cloned! You have now been redirected to the cloned template")
					vm.$router.push("/forms/child-template-editor/"+vm.$route.params.template_slug+"/"+response.slug)
				}
			})
		},
		selectTemplate() {
			let vm = this

			this.$nextTick(() => {
				let selectedTemplate = vm.formTemplates.find(temp => temp.id == vm.template_id)

				if (selectedTemplate) {
					vm.childTemplate = JSON.parse(selectedTemplate.template_json)
				}
				else
					vm.childTemplate = []

			})
		},
		saveChildTemplate() {
			let vm = this

			//remove empty tasks
			let cleanedTasks = []
			this.childTemplate.forEach(section => {
				section.fields.forEach(field => {
					if (field.type == 'tasklist' && field.value.length > 0) {
						let cleanedTaskList = field.value.filter(task => {
							if (typeof task == 'string')
								return true
							else
								return false
						})
						field.value = cleanedTaskList
					}
				})
			})

			let payload = {
				form_template_id: this.template_id,
				form_json: JSON.stringify(this.childTemplate),
				description: this.description,
				clockin_prompt_projects: this.clockin_prompt_projects,
				clockin_prompt_projects_required: this.clockin_prompt_projects_required,
				clockin_prompt_services: this.clockin_prompt_services,
				clockin_prompt_services_required: this.clockin_prompt_services_required,
			}

			if (this.id)
				payload.id = this.id

			this.working = true

			this.postData("FormChildTemplate/save",payload,true).then(response => {
				vm.working = false

				if (response.success) {
					vm.id = response.data.record_id
					vm.alertSaved("Child Template saved")

					if ("template_slug" in vm.$route.params)
						window.history.replaceState({},"","/forms/child-template-editor/"+vm.$route.params.template_slug+"/"+response.data.slug)
					else
						window.history.replaceState({},"","/forms/child-template-editor/"+response.data.slug)
				}
			})
		},
		fetchData() {
			let vm = this

			let templateParams = {
				include: ["FormTemplateCategory"],
				filters: [
					["category_id >",0]
				]
			}

			let promises = [
				this.getJSON("FormTemplate/get",templateParams),
				this.getJSON("EmployeeClassification/get", { orders: [['title', 'ASC']] }),
				this.fetchUsers(false,false,["id", "first_name", "last_name"])
			]

			let childTemplateFetchIndex = -1
			if ("slug" in this.$route.params && this.$route.params.slug != 'new') {
				const params = {
					include: [
						{
							model: 'CompanyFormRecurring',
							include: this.recurringInclude
						}
					]
				}

				promises.push(this.getJSON("FormChildTemplate/find/"+this.$route.params.slug, params))
				childTemplateFetchIndex = promises.length - 1
			}


			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[0].success)
					vm.formTemplates = responses[0].data

				if (responses[1].success)
					vm.employeeClassifications = responses[1].data

				if (childTemplateFetchIndex > -1)
					vm.setChildTemplate(responses[childTemplateFetchIndex].data)

				else if ("template_slug" in vm.$route.params) {
					let template = vm.formTemplates.find(temp => temp.title.slugify() == vm.$route.params.template_slug)

					if (template) {
						vm.selectTemplate(template)
						vm.template_id = template.id
					}
				}
			})
		},
	},
	created() {
		let vm = this

		this.fetchData()
	}
}
</script>

<style scoped>
	.child-template-section {
		padding: 15px;
		background: white;
		border: 1px solid #e0e0e0;
	}

	.task-item {
		position: relative;
		border: 1px solid #e0e0e0;
		padding: 5px;
		padding-top: 35px;
		margin-bottom: 10px;
	}

	.task-item .icon-button {
		position: absolute;
		top: 5px;
		right: 5px;
	}

	.list-cell {
		position: relative;
		padding-bottom: 140px;
	}

	.add-to-list-select {
		width: calc(100% - 10px);
		position: absolute;
		bottom: 70px;
	}

	.add-to-list-text {
		width: calc(100% - 10px);
		position: absolute;
		bottom: 0;
	}

	.hazard-control-list-item {
		position: relative;
		cursor: pointer;
	}

	.hazard-control-list-item .fa-trash {
		position: absolute;
		right: 0;
		display: none;
	}

	.hazard-control-list-item:hover .fa-trash {
		display: inline;
	}
</style>